import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Route, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { UtilsService } from '../lib/utils.service';

@Injectable({
  providedIn: 'root'
})
export class WritePermissionGuard  {

  constructor(private utilsService: UtilsService) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return new Observable<boolean>((observer) => {

      let permissions: string | string[] = next.data['writePermission'];

      let hasPermission: boolean = false;
      if (Array.isArray(permissions)) {

        // at least one permission is needed
        for (const permission of permissions) {
          if (this.utilsService.canWrite(permission)) {
            hasPermission = true;
            break;
          }
        }
      } else {
        hasPermission = this.utilsService.canWrite(permissions);
      }

      observer.next(hasPermission);
      observer.complete();
    });
  }
  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return true;
  }
  canDeactivate(
    component: unknown,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return true;
  }
  canLoad(
    route: Route,
    segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
    return true;
  }
}
